import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaArrowRight, FaCheck } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../redux/actions/CartActions";
import "./Service.css"; // <- nouveaux styles (titres uniformisés + centrage cards)

const servicesData = [
  {
    id: 1,
    icon: "/images/services2/creation.webp",
    title: "Création d'entreprise",
    intro:
      "Créez votre entreprise en toute simplicité avec un accompagnement complet et une identité visuelle professionnelle.",
    description: [
      // "Rédaction complète et personnalisée des statuts de votre société",
      "Registre de Commerce",
      "Statuts authentifiés de votre entreprise (SARL)",
      "Attestation de création d'entreprise",
      "Attestation de Conformité Fiscale (ACF)",
      "Numéro d’Identification Unique (NIU)",
    ],
    from: "creation",
  },
  {
    id: 2,
    icon: "/images/services2/domiciliation.webp",
    title: "Domiciliation d'entreprise",
    intro:
      "Offrez à votre entreprise une adresse prestigieuse,  avec une attestation de domiciliation prouvant que votre siège social est situé à un emplacement stratégique et reconnu.",
    description: [
      "Adresse administrative & fiscale (siège social) pour plus de crédibilité est mise à disposition dans le cadre de l’abonnement annuel.",
      "Mise à disposition d’une salle de réunion équipée, idéale pour recevoir vos clients",
      "Secrétariat bureautique pour la gestion et le traitement de vos documents",
      "Nous réceptionnons, trions, scannons et vous réexpédions votre courrier",
      "Localisation fiscale optimisée pour un meilleur contrôle de votre activité",
    ],
    from: "domiciliation",
  },
  {
    id: 3,
    icon: "/images/services2/gestion.webp",
    title: "Gestion 360°",
    intro:
      "Nous mettons à votre disposition un ERP cloud complet qui centralise l’ensemble de vos opérations. Facturation, gestion des ressources humaines, suivi client… vous pilotez votre entreprise à 360° depuis une seule plateforme, où que vous soyez.",
    description: [
      "Profitez d’un système de facturation moderne avec création automatisée de devis et factures, signature électronique intégrée et envoi direct à vos clients",
      "Accédez à un environnement entièrement digitalisé : toutes vos opérations sont accessibles en ligne depuis notre ERP cloud sécurisé, sans aucun déplacement nécessaire",
      "Suivez en temps réel l’évolution de votre entreprise grâce à une plateforme unique qui regroupe facturation, gestion RH et portefeuille client pour une visibilité totale",
    ],
    from: "management",
  },
  {
    id: 4,
    icon: "/images/services2/administration.webp",
    title: "Administration d'entreprise",
    intro:
      "Nous prenons en charge vos tâches administratives pour vous permettre de vous concentrer sur l'essentiel : le développement de votre activité.",
    description: [
      // "Comptabilité générale pour une gestion financière optimale",
      "Nous effectuons vos télé-déclarations mensuelles et vos déclarations fiscales, pour plus de sérénité",
      "Nous gérons vos cotisations sociales, sans stress et en toute conformité",
      "Suivi comptable rigoureux pour une vision claire de votre santé financière",
      "Optimisation fiscale pour maximiser vos bénéfices et réduire vos charges",
    ],
    from: "admin",
  },
  // {
  //   id: 5,
  //   icon: "/images/services2/ventes.webp",
  //   title: "Gestion de la Relation Client",
  //   intro:
  //     "Boostez votre activité commerciale avec une gestion optimisée et un suivi client structuré. Nous mettons à votre disposition un ERP cloud performant pour centraliser et simplifier votre gestion de la clientèle.",
  //   description: [
  //     "Un suivi client complet pour renforcer vos relations commerciales",
  //     "Relance client pour éviter les impayés et maximiser votre chiffre d'affaires",
  //     // "Mémorisation et transcription de réunions pour ne rien oublier",
  //     "Une gestion optimisée de vos contacts clients et prospects",
  //   ],
  //   from: "sales",
  // },
  // {
  //   id: 6,
  //   icon: "/images/services2/grh.webp",
  //   title: "Gestion des Ressources Humaines",
  //   intro:
  //     "Confiez-nous les informations de vos employés, et nous nous chargeons du reste ! Grâce à nos solutions adaptées et sécurisées, la gestion de vos ressources humaines devient simple et efficace.",
  //   description: [
  //     "Nous rédigeons et gérons vos contrats (contrat de travail, NDA, accords de mission)",
  //     "Nous réalisons les bulletins de paie de vos salariés à la demande",
  //     "Nous vous assistons lors des ruptures de contrat en garantissant une conformité légale optimisée",
  //   ],
  //   from: "grh",
  // },
  {
    id: 8,
    icon: "/images/services2/juridique.webp",
    title: "Suivi juridique",
    intro:
      "Nous vous accompagnons pour sécuriser votre entreprise et protéger vos intérêts. Confiez-nous vos besoins juridiques, et nous nous chargeons de tout.",
    description: [
      "Nous gérons vos contentieux professionnels et vous accompagnons à chaque étape",
      "Nous rédigeons vos contrats d’affaires pour des transactions sécurisées",
      "Nous assurons votre secrétariat juridique, pour une documentation toujours en règle",
    ],
    from: "juridique",
  },
  {
    id: 9,
    icon: "/images/services2/formalites.webp",
    title: "Gestion des formalités diverses",
    intro:
      "Simplifiez vos démarches administratives avec notre service clé en main.",
    description: [
      "Obtention d’autorisation d’importation rapidement et sans tracas",
      "Demande d’extrait de casier judiciaire simplifiée",
      "Obtention de certificat de célibat en un temps record",
      "Accompagnement pour l’ouverture de compte bancaire",
      "Montage de dossier de crédit bancaire et assistance personnalisée",
      "Aide à l’obtention d’un crédit-bail pour vos besoins d’investissement",
    ],
    path: "/formalities",
  },
];

const ServiceSection = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isAuthenticated, user } = useSelector((state) => state.authUser);
  const { userCompanies } = useSelector((state) => state.companies);

  const handleClick = async (service) => {
    if (service.path) {
      navigate(service.path);
    } else if (service.from !== "creation") {
      await dispatch(addToCart({ from: service.from }));

      if (isAuthenticated && user) {
        if (service.from === "admin") {
          const hasCMCompany =
            Array.isArray(userCompanies) &&
            userCompanies.some((company) => company.country === "CM");
          if (!hasCMCompany) {
            navigate("/business-country");
            return;
          }
        }
        if (Array.isArray(userCompanies) && userCompanies.length > 0) {
          navigate("/companies");
        } else {
          navigate("/business-country");
        }
      } else {
        navigate("/account-check");
      }
    } else if (service.from === "creation") {
      await dispatch(addToCart({ from: "creation" }));
      if (isAuthenticated && user) {
        navigate("/business-country");
      } else {
        navigate("/account-check");
      }
    }
  };

  return (
    <section id="services" className="services-wrap">
      <Container>
        {/* Titre principal uniformisé avec le Hero */}
        <div className="text-center mb-4">
          <p className="eyebrow mb-2">Nos services</p>
          <h2 className="hero-like-title">
            Des <span className="accent">solutions sur mesure</span> adaptées à
            vos besoins
          </h2>
          {/* garde ton ton, mais harmonisé */}
          <p className="hero-subtitle text-muted mx-auto">
            Du lancement à la croissance, Platform98 vous accompagne.
          </p>
        </div>

        {servicesData.map((service, index) => (
          <motion.div
            key={service.id}
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
            className="service-card-outer"
          >
            <Row
              className={`align-items-center py-5 px-4 rounded-4 card-elevated ${
                index % 2 === 0 ? "flex-row" : "flex-row-reverse"
              }`}
              style={{
                background:
                  "linear-gradient(160deg, #fff, #fff, #fff, #fff, #FF5500)",
                borderRadius: "16px",
                overflow: "hidden",
              }}
            >
              {/* Colonne image */}
              <Col md={6} className="text-center d-none d-md-block">
                <motion.img
                  src={service.icon}
                  alt={service.title}
                  className="img-fluid service-illustration"
                  initial={{ opacity: 0, scale: 0.92 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5, delay: index * 0.3 }}
                />
              </Col>

              {/* Colonne texte (listes intactes) */}
              <Col md={6} className="text-start px-md-5">
                <h3 className="service-title mb-3">{service.title}</h3>
                <p className="mb-3">{service.intro}</p>
                <ul className="list-unstyled service-list">
                  {service.description.map((item, i) => (
                    <li key={i}>
                      <FaCheck className="service-check" aria-hidden="true" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
                <Button
                  className="cta-orange mt-2"
                  onClick={() => handleClick(service)}
                >
                  Commencer maintenant <FaArrowRight className="ms-2" />
                </Button>
              </Col>
            </Row>
          </motion.div>
        ))}
      </Container>
    </section>
  );
};

export default ServiceSection;
